// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bgm_a bha_h","Menu__offsetParent":"bgm_b bha_bj","Menu__trigger--shadowed":"bgm_c"};